import { SERVICE } from '@src/api/types/shared/serviceType';
import CommonHelmet from '@src/components/CommonHelmet';
import TenantRoleGuard from '@src/components/guard/TenantRoleGuard';
import { TENANT_ROLE } from '@src/enum/tenantRoleEnum';
import SupportServicesListForm from '@src/features/tenant/supportServices/SupportServicesListForm';
import TenantDefaultLayout from '@src/layouts/tenant/TenantDefaultLayout';

function SupportServicesList() {
  return (
    <TenantRoleGuard
      canRoles={[TENANT_ROLE.ADMIN, TENANT_ROLE.CONTENT]}
      canService={[SERVICE.ENTERPRISE_PORTAL, SERVICE.DX_DIAGNOSIS]}
    >
      <TenantDefaultLayout>
        <CommonHelmet />
        <SupportServicesListForm />
      </TenantDefaultLayout>
    </TenantRoleGuard>
  );
}

export default SupportServicesList;
